import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFx = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 600 600",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M254.06,399.83c7.8,0,14.14-6.35,14.14-14.15v-10.46h16.44c24.66,0,44.73-20.06,44.73-44.73s-20.06-44.73-44.73-44.73h-61.25c-9.06,0-16.44-7.37-16.44-16.43s7.37-16.44,16.44-16.44h79.62c7.8,0,14.14-6.34,14.14-14.14s-6.34-14.15-14.14-14.15h-34.8v-10.28c0-7.8-6.34-14.15-14.14-14.15s-14.14,6.35-14.14,14.15v10.37h-16.44c-24.66,0-44.73,20.06-44.73,44.73s20.07,44.72,44.73,44.72h61.25c9.06,0,16.44,7.37,16.44,16.44s-7.37,16.44-16.44,16.44h-79.62c-7.8,0-14.14,6.34-14.14,14.14s6.34,14.15,14.14,14.15h34.81v10.37c0,7.8,6.34,14.15,14.14,14.15h-.01Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M408.76,436.4c-39.2,44.4-95.58,69.86-154.7,69.86-113.73,0-206.26-92.53-206.26-206.26S140.33,93.74,254.06,93.74c59.21,0,115.59,25.46,154.65,69.81,2.48,2.88,5.94,4.61,9.75,4.85,3.76.22,7.47-1.02,10.2-3.49,2.89-2.48,4.61-5.94,4.85-9.75.24-3.81-1.03-7.46-3.53-10.24-44.5-50.5-108.62-79.47-175.92-79.47-129.33,0-234.55,105.22-234.55,234.55s105.22,234.55,234.55,234.55c67.21,0,131.33-28.96,175.92-79.47,5.08-5.78,4.53-14.71-1.28-19.96-5.79-5.07-14.71-4.52-19.94,1.27h0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M576.33,267.07l-55.1-55.1c-5.5-5.5-14.46-5.5-19.97,0-5.5,5.5-5.5,14.46,0,19.97l30.93,30.93h-112.83c-7.8,0-14.14,6.34-14.14,14.14s6.34,14.15,14.14,14.15h146.94c5.7,0,10.84-3.38,13.14-8.7,2.15-5.3.93-11.34-3.11-15.38h0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M511.2,308.78h-146.94c-5.73,0-10.88,3.43-13.14,8.79-2.15,5.31-.93,11.35,3.11,15.38l55.19,55.19c2.73,2.6,6.26,4.03,9.94,4.03s7.39-1.53,9.94-4.21c2.67-2.67,4.14-6.22,4.14-9.99s-1.47-7.31-4.14-9.98l-30.93-30.93h112.83c7.8,0,14.14-6.34,14.14-14.14s-6.34-14.15-14.14-14.15h0Z"
		})
	]
});
export default SvgFx;
